import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Curedyne - Innovative solutions for health and wellness through natural remedies and supplements" 
          className="hero-image" 
        />
        <p className="eyebrow">Curedyne · Empowering Your Health Journey</p>
        <h1>Discover Natural Remedies for a Healthier You</h1>
        <p className="lede">
          Explore innovative solutions that enhance your wellness through nature's best offerings.
        </p>
        <div className="cta-row">
          <a href="/products" className="cta-button">
            Browse Our Remedies
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Comprehensive Natural Remedy Guides</h2>
          <p>
            Dive into our expertly crafted guides that help you understand the benefits and uses of various natural remedies.
          </p>
        </article>
        <article>
          <h2>In-Depth Supplement Reviews</h2>
          <p>
            Make informed decisions with our honest reviews of the latest health supplements on the market.
          </p>
        </article>
        <article>
          <h2>Wellness Tips for Everyday Life</h2>
          <p>
            Discover practical tips and strategies to enhance your overall well-being and integrate natural solutions into your routine.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;